$(function () {
  $('.fullHeightHero-carousel').flickity({
    lazyLoad: true,
    prevNextButtons: false,
    pageDots: true,
    wrapAround: true,
    autoPlay: 10000,
    pauseAutoPlayOnHover: false
  });
});